import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { MdInfoOutline, MdEdit } from 'react-icons/lib/md';
import { modalStyle } from '../../constants';
import { camelToTitle, formatPhoneNumber } from '../../utils';
import {
  fetchProject,
  fetchNotifications,
  fetchContractors
} from '../../actions/project_actions';
import {
  setCurrentTabIndex, setPMReqAEServProjId, fetch_lkp_ProjectProgramType, fetch_lkp_ProjectType,
  fetch_lkp_ProjectTypeForPb, fetchProjectType, postProjectTypes
} from '../../actions/additional_actions';
import { withAuth } from '../../actions/';

import InfoForm from './info_form';
import ReadonlyInfo from './ReadOnlyInfo';

import { fetch_lkp_Phase_AE, getAETrackingByProjectId } from '../../actions/additional_actions';
class ProjectInfo extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isEditable: false,
      isLoading: false,
      showNotifications: false,
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUomSubmit = this.handleUomSubmit.bind(this);
    this.toggleEditable = this.toggleEditable.bind(this);
    this.toggleNotifications = this.toggleNotifications.bind(this);
    this.saveWscope = this.saveWscope.bind(this);
    this.onPostProjectTypes = this.onPostProjectTypes.bind(this);
    this.getPhaseName = this.getPhaseName.bind(this);
  }

  componentDidMount() {
    const { projectId } = this.props;
    this.props.fetchProject(this.props.projectId);
    this.props.fetch_lkp_ProjectProgramType();
    this.props.fetch_lkp_ProjectType();
    this.props.fetch_lkp_ProjectTypeForPb();
    this.props.fetchProjectType(projectId);
    this.props.fetchNotifications(this.props.projectId);
    this.props.fetch_lkp_Phase_AE();
    this.props.getAETrackingByProjectId(this.props.projectId);
  }

  toggleEditable() {
    this.setState({ isEditable: !this.state.isEditable });
  }

  toggleNotifications() {
    this.setState({ showNotifications: !this.state.showNotifications });
  }

  getListProjectTypeModel(projectTypesSelected) {
    const { projectId } = this.props;
    let listProjectTypeModel = [];

    projectTypesSelected && projectTypesSelected.forEach(element => {
      var id = 0;
      var uomValue = null;
      var uomCost = null;

      if (element.hasOwnProperty('id')) {
        id = element.id;
        uomValue = element.uomValue;
        uomCost = element.uomCost;
      } else {
        id = element.value
      }

      listProjectTypeModel.push({ projectId, projectTypeId: id, uomValue, uomCost });
    });

    return listProjectTypeModel;
  }

  onPostProjectTypes() {
    const { projectId } = this.props;
    this.props.fetchProjectType(projectId);
  }

  handleSubmit(info) {
    const { postProjectTypes, projectId } = this.props;
    const lptm = this.getListProjectTypeModel(info.projectTypesSelected);
    lptm.id = projectId;
    postProjectTypes(lptm);

    const url = `/projects/${this.props.projectId}`;
    this.setState({ isLoading: true });

    return withAuth(
      { method: 'put', url: url, data: info },
      () => {
        this.toggleEditable();
        this.props.saveInfo(info);
        this.setState({ isLoading: false });
      }
    );
  }

  handleUomSubmit(info) {
    const { postProjectTypes, projectId } = this.props;
    this.setState({ isLoading: true });
    const lptm = this.getListProjectTypeModel(info.projectTypesSelected);
    lptm.id = projectId;
    lptm.onPostProjectTypes = this.onPostProjectTypes;

    postProjectTypes(lptm);

    this.setState({ isLoading: false });
  }

  saveWscope(info) {
    const url = `/projects/${this.props.projectId}`;
    this.setState({ isLoading: true });

    return withAuth(
      { method: 'put', url: url, data: info },
      () => {
        this.props.saveInfo(info);
        this.setState({ isLoading: false });
      }
    );
  }

  renderNotificationCounter() {
    const { notifications } = this.props;
    if (notifications.length === 0) return null;

    return (
      <div
        className="notifications"
        onClick={this.toggleNotifications}
      >
        <div className="counter">
          {notifications.length}
        </div>
      </div>
    )
  }

  renderNotifications() {
    const { notifications } = this.props;
    return (
      <Modal
        isOpen={this.state.showNotifications}
        style={modalStyle}
        contentLabel="Notification modal"
      >
        <div className="notification-modal">
          <h1>Notifications</h1>
          <ul className="notification-list">
            {notifications.map(notification =>
              <li key={notification.id}>
                <h4>{notification.subject}</h4>
                <p>{notification.message}</p>
              </li>
            )}
          </ul>
        </div>
        <div className="modal-close" onClick={this.toggleNotifications}>
          <span className="close"></span>
        </div>
      </Modal>
    );
  }

  renderContractor(contractor) {
    const { id, name, contractorSubEntities } = contractor;

    return (
      <div key={id} className="col s12">
        <div className="contractor">
          <h6 className="col s12">{name}</h6>
          <div className="row">
            {contractorSubEntities.map(entity =>
              <div key={entity.id} className="col s12 l4">
                <div className="entity">
                  <strong>{camelToTitle(entity.type)}</strong>
                  {entity.name ? <span>{entity.name}</span> : null}
                  {entity.address ? <span>{entity.address}</span> : null}
                  {entity.tel && <span>Phone: {formatPhoneNumber(entity.tel)}</span>}
                  {entity.fax && <span>Fax: {entity.fax}</span>}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderContractors() {
    return null;
  }

  getPhaseName(phases_AE, aeTracksMain) {
    let currentPhase;
    currentPhase = _.find(phases_AE, function (o) { return o.id === aeTracksMain[0].currentPhaseId; });
    if (aeTracksMain[0].currentPhaseId == null) {
      currentPhase = _.find(phases_AE, function (o) { return o.id === aeTracksMain[0].trackingPhase_AE[aeTracksMain[0].trackingPhase_AE.length - 1].phaseId; });
    }
    if (currentPhase)
      return currentPhase.phaseName;
    else return null;
  }

  render() {
    const { info, permissions, subPhases, benchmarkStatuses, setCurrentTabIndex, projectTypes, projectTypesSelected,
      projectProgramTypes, setPMReqAEServProjId, projectTypesPb, phases_AE, aeTracksMain } = this.props;

    const { isEditable, isLoading } = this.state;

    const { roleModules } = permissions.editPrivileges;
    const canShowForm = roleModules !== null && roleModules.includes('Project Info') && isEditable && !isLoading
      ? true : false;
    const canShowButtons = roleModules !== null && roleModules.includes('Project Info') && !isLoading
      ? true : false;

    const canEditWebScope = roleModules !== null && roleModules.includes('Project Info') ? true : false;

    const className = 'row-wide project-info' + (isEditable ? ' editable' : '');

    // if (phases_AE.length === 0) this.props.fetch_lkp_Phase_AE();
    // if(aeTracksMain.length === 0 ) this.props.getAETrackingByProjectId(info.projectId);    
    return (
      <div>
        <div id="info" className={className}>
          <div className="col s12">
            <h4 className="bar-bottom">
              <span><MdInfoOutline size={20} /></span> Project Info
              {canShowButtons ?
                <span className='fa-Icon-Edit' onClick={this.toggleEditable}><MdEdit size={22} color='#8492a6' /></span>
                : null}
            </h4>
          </div>

          {canShowForm ?
            <InfoForm
              info={info}
              setup={this.props.setup}
              projectTypesSelected={projectTypesSelected}
              projectTypes={projectTypes}
              programTypes={projectProgramTypes}
              onSubmit={this.handleSubmit}
              onCancel={this.toggleEditable}
              subPhases={subPhases}
              benchmarkStatuses={benchmarkStatuses}
              canEditWs={canShowButtons}
              saveWs={this.saveWscope}
              canEditWebScope={canEditWebScope}
              phaseName={aeTracksMain.length > 0 && this.getPhaseName(phases_AE, aeTracksMain)}
            />
            : <ReadonlyInfo
              info={info}
              setCurrentTab={setCurrentTabIndex}
              setPMReqAEServ={setPMReqAEServProjId}
              projectTypesSelected={projectTypesSelected}
              projectTypes={projectTypes}
              projectTypesPb={projectTypesPb}
              onSubmit={this.handleSubmit}
              onUomSubmit={this.handleUomSubmit}
              programTypes={projectProgramTypes}
              canEditWs={canShowButtons}
              saveWs={this.saveWscope}
              canEditWebScope={canEditWebScope}
              saveInfo={this.props.saveInfo}
              phaseName={aeTracksMain.length > 0 && this.getPhaseName(phases_AE, aeTracksMain)}
            />
          }

          {isLoading ? <div className="loader" /> : null}
        </div>

        {this.renderContractors()}
      </div>
    );
  }

}


function saveInfo(info) {
  return dispatch => {
    dispatch({
      type: 'SET_CURRENT_INFO',
      data: info
    })
  }
}

ProjectInfo.propTypes = {
  projectId: PropTypes.string.isRequired,
  permissions: PropTypes.object.isRequired,
  notifications: PropTypes.array.isRequired,
  info: PropTypes.object.isRequired,
  contractors: PropTypes.array.isRequired,
  setup: PropTypes.object.isRequired,
  fetchProject: PropTypes.func.isRequired,
  fetchContractors: PropTypes.func.isRequired,
  fetchNotifications: PropTypes.func.isRequired,
  saveInfo: PropTypes.func.isRequired,
  setCurrentTab: PropTypes.func,
  setPMReqAEServ: PropTypes.func
};

function mapStateToProps(state, ownProps) {
  return {
    info: state.projectsStore.info,
    contractors: state.projectsStore.contractors,
    notifications: state.projectsStore.notifications,
    setup: state.projectsStore.setup,
    subPhases: state.projectsStore.subPhases,
    benchmarkStatuses: state.projectsStore.benchmarkStatuses,
    projectProgramTypes: state.additionalProjectsStore.projectProgramTypes,
    projectTypes: state.additionalProjectsStore.projectTypes,
    projectTypesPb: state.additionalProjectsStore.projectTypesPb,
    projectTypesSelected: state.additionalProjectsStore.projectTypesSelected,
    aeTracksMain: state.additionalProjectsStore.aeTracksMain,
    phases_AE: state.additionalProjectsStore.phases_AE,
  };
}

export default connect(mapStateToProps, {
  fetchProject,
  fetch_lkp_ProjectType,
  fetch_lkp_ProjectTypeForPb,
  fetch_lkp_ProjectProgramType,
  fetchProjectType,
  postProjectTypes,
  fetchContractors,
  fetchNotifications,
  saveInfo,
  setCurrentTabIndex,
  setPMReqAEServProjId,
  fetch_lkp_Phase_AE,
  getAETrackingByProjectId
})(ProjectInfo);
